import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { popNotification } from '..'
import { useNavigate } from 'react-router-dom'
import { discardWarrantyData } from '../store/dataSlice'

// Payment
import { apiAcceptWarranty, apiDownloadWarranty } from 'services/LoveWarrantyServices'
import PaymentModal from 'views/warranties/WarrantyActions/PaymentModal'
import { Button } from 'components/ui'

export const Complete = ({ closeModal, isModal }) => {
    const dispatch = useDispatch()
    const { warranty } = useSelector((state) => state.createWarranty.data)
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()
    const [paymentSuccess, setPaymentSuccess] = useState(false);
    const [downloading, setDownloading] = useState(false)

    const onComplete = () => {
        if (isModal) closeModal()
        dispatch(discardWarrantyData())
        navigate(`/app/warranties/edit-warranty/${warranty.id}?payment=success`)
    }

    const onAccept = async () => {
        setLoading(true)

        try {
            const resp = await apiAcceptWarranty({
                id: parseInt(warranty.id)
            })

            if (resp && resp.status === 201) {
                popNotification("Guarantee Accepted", 2000, "Success", "success")

                setTimeout(() => {
                    // getPaymentURL()
                    setLoading(false)
                }, 1000)
            }
            // ALREADY ACCEPTED
            else if (resp.status === 422) {
                setTimeout(() => {
                    // getPaymentURL()
                    setLoading(false)
                }, 1000)
            }
            else {
                const error = resp.message
                popNotification(error, 2000, "Error", "danger")
            }

            setLoading(false)
        } catch (err) {
            if (err.response.status === 422) {
                // warranty is already accepted
                // if (closeModal) closeModal()
                // setLoading(false)
            }

            popNotification(err.response.data.message, 2000, "Error", "danger")
            setLoading(false)
        }
    }

    const downloadPDF = async () => {
        setDownloading(true)
        const resp = await apiDownloadWarranty(warranty.id)

        if (resp) {
            const { url } = resp.data

            const link = document.createElement('a')
            link.href = url
            document.body.appendChild(link)
            link.click()
            link.parentNode.removeChild(link)
        }

        setDownloading(false)
    }

    return (
        <div className='flex justify-center flex-col w-full mx-auto h-full'>
            {paymentSuccess ? (
                <>
                    <i className="fas fa-party-horn text-3xl text-black text-left w-full mb-3"></i>
                    <h2 className="text-xl font-bold text-black w-full text-left">Success!</h2>
                    <span className="text-black w-full text-left">Your new Guarantee DGS-{warranty.id} has been created! Click below to view now.</span>
                    <div className="flex items-center justify-start w-full mt-4 gap-2">
                        <Button
                            size="sm"
                            type="button"
                            variant="solid"
                            onClick={() => {
                                onComplete()
                            }}
                        >
                            View Guarantee
                        </Button>
                        <Button
                            size="sm"
                            type="button"
                            variant="solid"
                            color="custom-900"
                            className="!text-black"
                            disabled={downloading}
                            loading={downloading}
                            onClick={() => {
                                downloadPDF()
                            }}
                        >
                            Download
                        </Button>
                    </div>
                </>
            ) : (
                <>
                    <h2 className="text-xl font-bold text-black w-full text-left">Payment</h2>
                        <span className="text-black w-full text-left">Your Guarantee has been saved!</span>
                    <PaymentModal
                        warranty={warranty}
                        buttonOnClick={onAccept}
                        onComplete={() => {
                            setPaymentSuccess(true)
                        }}
                        asModal={false}
                    />
                </>
            )}
        </div>
    )
}